import { ORDER_METHODS } from '../../../../../services/exports/Constants';
import { ValidationErrors } from '../../../../../modals/order-method/types';

export default {
  title: 'Sélectionner un emplacement',
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'Commande à table',
    [ORDER_METHODS.PICKUP]: 'À emporter',
    [ORDER_METHODS.DELIVERY]: 'Livraison',
  },
  text_inputs: {
    address: {
      placeholder: 'Recherchez votre adresse',
    },
    street_name: {
      placeholder: 'Rue',
    },
    street_number: {
      placeholder: 'Numéro de rue',
    },
    city: {
      placeholder: 'Ville',
    },
    zip: {
      placeholder: 'CP',
    },
  },
  time_options: {
    asap: {
      title: 'Standard',
      description: 'Prêt en {{time}} min',
    },
    scheduled: {
      title: 'Planifier pour plus tard',
    },
  },
  time_drop_down: {
    today: "Aujourd'hui",
  },

  pickup: {
    address: 'Adresse de retrait',
    when: 'Quand ?',
  },

  delivery: {
    where: 'Où ?',
    when: 'Quand ?',
    address: 'Votre adresse',
    delivery_area: 'Notre zone de livraison',
  },

  buttons: {
    view_menu: 'Voir le menu',
    see_hours: 'Voir les horaires',
    next: 'Suivant',
    change: 'Modifier',
    save: 'Enregistrer',
  },

  labels: {
    when: 'Quand ?',
    pickup: 'Retrait en ligne',
    delivery: 'Livraison',
    pickup_time: 'heure de retrait',
    delivery_time: 'heure de livraison',
    discount: 'Seulement ici {{value}} de réduction en ligne',
    pre_orders_enabled: "Pour l'instant, vous pouvez planifier une commande pour plus tard",
    change_location: '← Retournez au menu si vous préférez un autre emplacement',
    return: 'Retour',
  },

  items_dropped: {
    count_one: '{{count}} article retiré',
    count_other: '{{count}} articles retirés',
    pickup_reason: '— non disponible pour le retrait.',
    delivery_reason: '— non disponible pour la livraison.',
  },

  error_messages: {
    [ValidationErrors.address_not_found]:
      "Désolé, nous n'avons pas trouvé cette adresse. Veuillez réessayer en saisissant d'abord la rue dans le champ de recherche d'adresse.",
    [ValidationErrors.address_not_serviceable]:
      'Votre adresse est hors de notre zone de livraison. Souhaitez-vous modifier votre adresse ou passer à une commande à emporter ? 😊',
    [ValidationErrors.no_drivers_available]:
      'Désolé, nous ne pouvons pas livrer pour le moment. Souhaitez-vous commander à emporter ? 😊',
    pickup_unavailable: 'Nous sommes désolés, nous ne proposons pas de retrait actuellement.',
    delivery_unavailable: 'Nous sommes désolés, nous ne proposons pas de livraison actuellement.',
    delivery_paused: 'Nous sommes désolés, nous ne proposons pas de livraison actuellement.',
    outside_pickup_times: 'Nous ne proposons pas de retrait à cette heure. Nos horaires de retrait :',
    outside_delivery_times: 'Nous ne proposons pas de livraison à cette heure. Nos horaires de livraison :',
    orders_paused_inactivity:
      "En raison d'une demande exceptionnelle, nous ne pouvons pas accepter davantage de commandes en ligne pour le moment. Veuillez commander en magasin ou réessayer dans 30 minutes.",
    orders_paused_manual_end_of_day: 'Désolé, nous sommes fermés pour le reste de la journée.',
    orders_paused_manual_until_time:
      "En raison d'une demande exceptionnelle, nous ne pouvons pas accepter davantage de commandes en ligne pour le moment. Veuillez commander en magasin ou réessayer à partir de {{pausedUntil}}",
    company_closed: 'Malheureusement, nous ne sommes pas ouverts en ce moment.',
    pickup_closed:
      "Nous acceptons les commandes à emporter jusqu'à {{time}} car notre temps de préparation est de {{preparationTime}} minutes.",
    delivery_closed:
      "Nous acceptons les commandes en livraison jusqu'à {{time}} car notre délai de livraison est de {{preparationTime}} minutes.",
    live_orders_off:
      'Nous sommes désolés, nous ne pouvons pas accepter davantage de commandes en ligne pour le moment. Merci de votre compréhension.',
    orders_unavailable:
      "{{type}} n'est pas disponible pour le moment. Le prochain {{typeTime}} possible est le {{day}} à {{time}}.",
  },

  no_couriers: {
    with_code:
      "Nous sommes désolés, nous n'avons pas de livreur disponible en ce moment. Veuillez réessayer plus tard, ou commandez à emporter et utilisez le code promo <PromoCode>{{code}}</PromoCode> lors du paiement.",
    without_code:
      "Nous sommes désolés, nous n'avons pas de livreur disponible en ce moment. Veuillez réessayer plus tard, ou commandez à emporter.",
    copied: 'Code promo copié',
  },
};
